export default "__VITE_ASSET__DkOa$Kei__"